module.exports = __webpack_public_path__ + "static/img/2.49d247d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/temp/2.jpg
// module id = PEbK
// module chunks = 1